export const ErrorResult = ({ error }: { error: any }) => {
  return <div>{JSON.stringify(error)}</div>;
};
